import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const AnimateHeight = ({ className, children, toggled, transitionDuration, allowOverflow }) => {
  const [animate, setAnimate] = useState(false);
  const [overflow, setOverflow] = useState('hidden');

  useEffect(() => {
    if (toggled) {
      setOverflow('hidden');
      if (allowOverflow) {
        setTimeout(() => setOverflow('visible'), transitionDuration * 1000);
      }
    }
    setAnimate(toggled);
  }, [toggled]);

  return (
    <div
      className={`animate-height-container ${animate ? 'toggled' : ''} ${className}`}
      style={{ transition: `grid-template-rows ${transitionDuration}s ease-out`}}
    >
      <div className="inner-container" style={{ overflow }}>
        {children}
      </div>
    </div>
  );
}


AnimateHeight.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  toggled: PropTypes.bool,
  transitionDuration: PropTypes.number,
  allowOverflow: PropTypes.bool
};

AnimateHeight.defaultProps = {
  className: '',
  transitionDuration: 0.2,
  toggled: false
};

export default AnimateHeight;
